export default String.raw`
{% include 'partials/companies/companies.html' with "brands" -%}
<div class="categories-map">
    <div class="categories-map__title">{{ translations.Categories }}</div>
    <div class="categories-map__categories">
        {% for node in products.Products -%}
            <a class="category" href="{{ page.BaseHref }}{{ node.Url }}" title="{{ node.Name | H }}">
                <div class="category__image">
                    {% if node.ImageId == -1 -%}
                        <svg class="no-image">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
                        </svg>
                    {% else -%}
                        {{ node | Img: 'medium' }}
                    {% endif -%}
                </div>
                <div class="category__name">{{ node.Name }}</div>
            </a>
        {% endfor -%}
    </div>
</div>
`